import React, { useState, useCallback } from 'react';
import Cropper from 'react-easy-crop';
import './ImageCropModal.css';

/**
 * Get cropped image as base64 data URL from crop area.
 */
const getCroppedImg = (imageSrc, pixelCrop, size = 400, quality = 0.85) => {
    return new Promise((resolve) => {
        const image = new Image();
        image.onload = () => {
            const canvas = document.createElement('canvas');
            canvas.width = size;
            canvas.height = size;
            const ctx = canvas.getContext('2d');

            ctx.drawImage(
                image,
                pixelCrop.x,
                pixelCrop.y,
                pixelCrop.width,
                pixelCrop.height,
                0,
                0,
                size,
                size
            );

            resolve(canvas.toDataURL('image/jpeg', quality));
        };
        image.src = imageSrc;
    });
};

const ImageCropModal = ({ imageSrc, onCropComplete, onCancel, aspect = 1 }) => {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    const onCropChange = useCallback((_, croppedArea) => {
        setCroppedAreaPixels(croppedArea);
    }, []);

    const handleConfirm = async () => {
        if (croppedAreaPixels) {
            const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
            onCropComplete(croppedImage);
        }
    };

    return (
        <div className="crop-modal-overlay">
            <div className="crop-modal">
                <div className="crop-container">
                    <Cropper
                        image={imageSrc}
                        crop={crop}
                        zoom={zoom}
                        aspect={aspect}
                        onCropChange={setCrop}
                        onZoomChange={setZoom}
                        onCropComplete={onCropChange}
                    />
                </div>
                <div className="crop-controls">
                    <label className="zoom-label">
                        缩放
                        <input
                            type="range"
                            min={1}
                            max={3}
                            step={0.1}
                            value={zoom}
                            onChange={(e) => setZoom(Number(e.target.value))}
                            className="zoom-slider"
                        />
                    </label>
                    <div className="crop-actions">
                        <button type="button" onClick={onCancel} className="btn btn-secondary">取消</button>
                        <button type="button" onClick={handleConfirm} className="btn btn-primary">确认裁剪</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ImageCropModal;
